import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUploadHolidayAllowanceSalaryMutation } from "../../features/payrollSetting/payrollSettingApi";
import useError from "../../hooks/useError";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import UploadExcelModal from "../common/UploadExcelModal";

export default function HolidaySalaryModal({
  open,
  handleClose,
}: ModalComponentProps) {
  const navigate = useNavigate();
  const [
    uploadHolidayAllowanceSalary,
    { isLoading, isError, error, isSuccess },
  ] = useUploadHolidayAllowanceSalaryMutation();
  useError(isError, error, "Holiday allowance salary fail");
  const [formData, setFormData] = useState<FormData | null>(null);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Holiday allowance salary updated successfully");
      return handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, navigate]);

  return (
    <UploadExcelModal
      open={open}
      handleClose={handleClose}
      isLoading={false}
      handler={setFormData}
      title="Holiday Allowance Salary Data in Bulk"
      warningText="Please enter the year as a four-digit number (e.g., 2025, 2024) and the month as a number (e.g., 1 for January, 12 for December)."
      downloadLink={"/sample-holiday-allowence.xlsx"}
      footer={
        <Space size={12}>
          <Button
            className="modal-button"
            type="primary"
            loading={isLoading}
            onClick={() => uploadHolidayAllowanceSalary(formData)}
          >
            Upload
          </Button>
        </Space>
      }
    />
  );
}
